/* eslint @typescript-eslint/no-explicit-any: 0 */
import switcher from "./switcher.mjs";
export default (k, m) => switcher(k, m)();
//# sourceMappingURL=switcherFn.mjs.map